import React, { createContext, useState, useEffect, useContext } from "react";
import api from "../../services/api";
import useWhatsApps from "../../hooks/useWhatsApps";
import IncomingCallNotification from "../../components/WavoipCall/IncomingCallNotification";
import { AuthContext } from "../Auth/AuthContext";

const WhatsAppsContext = createContext();

const WhatsAppsProvider = ({ children }) => {
  const whatsAppData = useWhatsApps();
  const { loading = false, whatsApps = [], refreshWhatsApps } = whatsAppData || {};
  const { user } = useContext(AuthContext);
  
  const [wavoipToken, setWavoipToken] = useState(null);

  useEffect(() => {
    const fetchSession = async () => {
      try {
        // Tenta primeiro pelo whatsapp do usuário
        const { data } = await api.get("/call/historical/user/whatsapp");
        console.log('[WavoIP Context] Resposta da API:', data);
        let token = data?.whatsapp?.wavoip || null;

        // Se não encontrou, busca qualquer whatsapp da empresa com token wavoip
        if (!token) {
          const { data: wavoipData } = await api.get("/call/whatsapp/wavoip");
          token = wavoipData?.whatsapp?.wavoip || null;
          console.log('[WavoIP Context] Token via fallback:', token);
        }

        console.log('[WavoIP Context] Token final:', token);
        setWavoipToken(token);
      } catch (err) {
        console.error('[WavoIP Context] Erro ao buscar token:', err);
        setWavoipToken(null);
      }
    };
    fetchSession();
  }, []);

  return (
    <WhatsAppsContext.Provider value={{ whatsApps, loading, refreshWhatsApps }}>
      {children}
      {wavoipToken && <IncomingCallNotification token={wavoipToken} />}
    </WhatsAppsContext.Provider>
  );
};

export { WhatsAppsContext, WhatsAppsProvider };